import { inject, Injectable, signal } from '@angular/core'
import { EventTypes, OidcSecurityService, PublicEventsService } from 'angular-auth-oidc-client'
import { OidcToken } from '../models/auth.model'
import { Observable } from 'rxjs'
import { filter } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class AuthService {
  public readonly isAuthenticated = signal(false)
  public readonly userData = signal<OidcToken | null>(null)
  private readonly _accessToken = signal<string | null>(null)
  private readonly oidcSecurityService = inject(OidcSecurityService)
  private readonly eventService = inject(PublicEventsService)

  constructor() {
    this.oidcSecurityService.isAuthenticated$.subscribe(({ isAuthenticated }) => {
      this.isAuthenticated.set(isAuthenticated)
    })

    this.oidcSecurityService.userData$.subscribe(({ userData }) => {
      this.userData.set(userData as OidcToken)
    })

    this.oidcSecurityService.getAccessToken().subscribe((token) => {
      this._accessToken.set(token)
    })

    this.eventService.registerForEvents()
      .pipe(filter((e) => e.type === EventTypes.NewAuthenticationResult))
      .subscribe(() => {
        this.oidcSecurityService.getAccessToken().subscribe((token) => {
          this._accessToken.set(token)
        })
      })
  }

  public get userName(): string {
    return this.userData()?.name ?? this.userData()?.preferred_username ?? ''
  }

  public get accessToken(): string {
    return this._accessToken() ?? ''
  }

  public login(): void {
    this.oidcSecurityService.authorize()
  }

  public loginRedirect(): void {
    this.oidcSecurityService.authorize()
  }

  public logout(): void {
    this.oidcSecurityService.logoff().subscribe(() => {
      /*
      Subscribe seems necessary since https://stackoverflow.com/questions/64239572/angular-auth-oidc-client-logout-not-working
       */
    })
  }

  public handleRedirectPromise(): Observable<unknown> {
    return this.oidcSecurityService.checkAuth()
  }

  public acquireTokenSilent(): Observable<unknown> {
    return this.oidcSecurityService.forceRefreshSession()
  }
}
